module.exports = __webpack_public_path__ + "media/application/images/partners/footer_supporters-64bfae5589ddbfcac7f3cb0d36924234.png";